class MobileMenu extends ViewBasic {
    constructor(options) {
        super(options);

    }

    init() {
        this.isCollapsed = false;
        this.lastScrollTop = 0;

        this.$siteHeader = $('#site-header');



        this.addEvents();
    }

    addEvents() {
        $(window).scroll(e => this.scrollHandler(e));

        //All subscribe
        Me.dispatch.subscribe('breakpointChanged', $.proxy(this.breakpointHadler, this));
    }

    removeEvents() {

    }

    scrollHandler() {
        this.$headerHeight = this.$el.height();
        this.$navigationHeight = this.$('.main-navigation').height();

        if ($(window).width() < SETTINGS.BREAKPOINTS.CUSTOMMENU_MIN) {

            let currentScrollTop = $(window).scrollTop();

            if (currentScrollTop > this.lastScrollTop) {
                // downscroll code
                if (currentScrollTop > 70 && !this.isCollapsed) {
                    this.isCollapsed = true;
                    this.$el.css('top', -(this.$navigationHeight));

                    this.$el.addClass('isCollapsed');

                    // this.$siteHeader.css('padding-top', this.$headerHeight - this.$navigationHeight);

                    Me.dispatch.emit('MobileMenu.changeState', this, {isCollapsed: true});
                    // let newMenuCategoryTop = this.$headerHeight + parseInt(this.$el.css('top'));
                    //this.$menuCategory.css('top', newMenuCategoryTop);
                    // console.log(newMenuCategoryTop);
                }
            } else {
                // upscroll code
                if (this.isCollapsed) {
                    this.isCollapsed = false;
                    this.$el.css('top', '0');

                    this.$el.removeClass('isCollapsed');
                    // this.$siteHeader.css('padding-top', this.$headerHeight);

                    Me.dispatch.emit('MobileMenu.changeState', this, {isCollapsed: false});
                }

            }

            this.lastScrollTop = currentScrollTop;
        }
    }

    breakpointHadler(e, params) {
        if ($(window).width() > SETTINGS.BREAKPOINTS.CUSTOMMENU_MIN) {
            this.isCollapsed = false;
            this.$el.css('top', '0');

            if(this.$el.hasClass('isCollapsed')){
                this.$el.removeClass('isCollapsed');
            }

        }
    }
}
